"use strict";(()=>{var zt=Object.defineProperty;var Bt=(e,t,s)=>t in e?zt(e,t,{enumerable:!0,configurable:!0,writable:!0,value:s}):e[t]=s;var $t=(e,t,s)=>Bt(e,typeof t!="symbol"?t+"":t,s);var kt=(e,t,s)=>new Promise((i,a)=>{var c=p=>{try{d(s.next(p))}catch(u){a(u)}},n=p=>{try{d(s.throw(p))}catch(u){a(u)}},d=p=>p.done?i(p.value):Promise.resolve(p.value).then(c,n);d((s=s.apply(e,t)).next())});var Z=class{constructor(t){this.container=t,this.tabList=this.container.querySelector(".js-tablist"),this.tabLinks=this.container.querySelectorAll(".js-tablist__link"),this.tabPanels=this.container.querySelectorAll(".js-tabcontent"),this.init()}init(){if(!this.tabList||!this.tabLinks.length||!this.tabPanels.length){console.warn("CustomTabs: Required elements not found",{tabList:!!this.tabList,tabLinks:this.tabLinks.length,tabPanels:this.tabPanels.length});return}this.setupAccessibility(),this.bindEvents(),this.activateFirstTab()}setupAccessibility(){this.tabList.setAttribute("role","tablist"),this.tabLinks.forEach((t,s)=>{let i=this.tabPanels[s],a=`tab-${this.container.id||"custom"}-${s}`,c=`panel-${this.container.id||"custom"}-${s}`;t.setAttribute("role","tab"),t.setAttribute("id",a),t.setAttribute("aria-selected","false"),t.setAttribute("aria-controls",c),t.setAttribute("tabindex","-1"),i&&(i.setAttribute("role","tabpanel"),i.setAttribute("id",c),i.setAttribute("aria-labelledby",a),i.setAttribute("aria-hidden","true"),i.setAttribute("tabindex","0"))})}bindEvents(){this.tabLinks.forEach(t=>{t.addEventListener("click",s=>{s.preventDefault(),this.activateTab(t)}),t.addEventListener("keydown",s=>{this.handleKeydown(s,t)})})}handleKeydown(t,s){let i=Array.from(this.tabLinks).indexOf(s),a;switch(t.key){case"ArrowLeft":t.preventDefault(),a=this.tabLinks[i-1]||this.tabLinks[this.tabLinks.length-1],this.activateTab(a);break;case"ArrowRight":t.preventDefault(),a=this.tabLinks[i+1]||this.tabLinks[0],this.activateTab(a);break;case"Home":t.preventDefault(),this.activateTab(this.tabLinks[0]);break;case"End":t.preventDefault(),this.activateTab(this.tabLinks[this.tabLinks.length-1]);break}}activateTab(t){let s=Array.from(this.tabLinks).indexOf(t);if(!this.tabPanels[s]){console.warn("CustomTabs: Panel not found for tab",t);return}this.tabLinks.forEach((a,c)=>{let n=c===s;a.setAttribute("aria-selected",n),a.setAttribute("tabindex",n?"0":"-1"),n?a.setAttribute("data-selected","1"):a.removeAttribute("data-selected")}),this.tabPanels.forEach((a,c)=>{let n=c===s;a.setAttribute("aria-hidden",!n),n?a.removeAttribute("tabindex"):a.setAttribute("tabindex","-1")}),t.focus()}activateFirstTab(){let t=this.tabLinks[0];t&&this.activateTab(t)}activateTabByIndex(t){let s=this.tabLinks[t];s&&this.activateTab(s)}activateTabById(t){let s=this.container.querySelector(`#${t}`);s&&this.activateTab(s)}};function N(){document.querySelectorAll(".js-tabs").forEach(t=>{new Z(t)})}document.readyState==="loading"?document.addEventListener("DOMContentLoaded",N):N();var Wt=e=>{class t extends HTMLElement{constructor(){var i,a,c,n;super(),this.header=e,this.detailsElem=this.querySelector("details"),this.summaryElem=(i=this.detailsElem)==null?void 0:i.querySelector("summary"),this.megaMenu=(a=this.summaryElem)==null?void 0:a.nextElementSibling,this.megaMenuList=(c=this.megaMenu)==null?void 0:c.querySelector("[data-mega-menu-level-2-list]"),this.level2Links=(n=this.megaMenuList)==null?void 0:n.querySelectorAll(".header__menu-item--level-2"),this.megaMenuBarHeight=getComputedStyle(this.header).getPropertyValue("--megamenu-level-2-bar-height")}connectedCallback(){this.initLevel1Listeners(),this.initLevel2Listeners(),this.openOnPageLoad()}initLevel1Listeners(){this.summaryElem.addEventListener("click",i=>{var c;i.preventDefault();let a=this.header.querySelector("custom-header-menu .open");this.detailsElem.classList.contains("open")||(this.summaryElem.setAttribute("aria-expanded",!0),this.detailsElem.setAttribute("open",!0),requestAnimationFrame(()=>{this.detailsElem.classList.add("open")})),a&&a!==this.detailsElem&&(a.classList.remove("open"),(c=a.querySelector("summary"))==null||c.setAttribute("aria-expanded",!1),requestAnimationFrame(()=>{a.removeAttribute("open")})),requestAnimationFrame(()=>{var n;(n=this.level2Links[0])==null||n.dispatchEvent(new MouseEvent("mouseenter"))}),e.classList.contains("section-header--scrolling-down")&&e.scrollController.triggerDirection("up")})}initLevel2Listeners(){var i,a;(i=this.level2Links)==null||i.forEach(c=>{c.addEventListener("mouseenter",()=>{var p;let n=c.nextElementSibling,d=n?`${n.scrollHeight+48}px`:this.megaMenuBarHeight;this.closeExpandedLevel2Menu(),(p=c.closest("li"))==null||p.classList.add("is-expanded"),this.megaMenuList&&(this.megaMenuList.style.height=d)})}),(a=this.megaMenuList)==null||a.addEventListener("mouseleave",()=>{this.megaMenuList.style.height=`${this.megaMenuBarHeight}`,this.closeExpandedLevel2Menu()})}closeExpandedLevel2Menu(){var a;let i=(a=this.megaMenuList)==null?void 0:a.querySelector(".is-expanded");i==null||i.classList.remove("is-expanded")}openOnPageLoad(){if(!this.detailsElem||!this.summaryElem)return;let i=sessionStorage.getItem("lastClickedMenuId");if(!i){let a=this.header.querySelector("[data-header-menu-id]");i=a==null?void 0:a.getAttribute("data-header-menu-id")}this.detailsID=this.detailsElem.getAttribute("data-header-menu-id"),i===this.detailsID&&(this.detailsElem.setAttribute("open",!0),this.detailsElem.classList.add("open"),this.summaryElem.setAttribute("aria-expanded","true"))}}customElements.get("custom-header-menu")||customElements.define("custom-header-menu",t)},Ht=e=>{let t=0,s=null,i=!1,a=20,c=n=>{n!==s&&(s=n,e(n))};return window.addEventListener("scroll",()=>{i||(requestAnimationFrame(()=>{let n=window.scrollY;if(Math.abs(n-t)>a){let p=n>t?"down":"up";c(p),t=n}i=!1}),i=!0)},{passive:!0}),{triggerDirection:n=>{c(n),t=window.scrollY}}},Vt=e=>{Wt(e);let t=()=>{let n=window.matchMedia("(max-width: 989px)").matches?"[data-header-drawer-nav]":"[data-header-nav]",d=e.querySelector(n),p=d==null?void 0:d.querySelectorAll("a");p==null||p.forEach(u=>{u.addEventListener("click",()=>{let h=u.closest("[data-header-menu-id]");if(!h)return;let b=h.getAttribute("data-header-menu-id");sessionStorage.setItem("lastClickedMenuId",b)})})};t();let s=window.matchMedia("(max-width: 989px)");if(!s.matches){let n=Ht(d=>{e.classList.remove("section-header--scrolling-up","section-header--scrolling-down"),e.classList.add(`section-header--scrolling-${d}`)});e.scrollController=n}let i=!1,a=()=>{let n=sessionStorage.getItem("lastClickedMenuId");if(!n)return;let d=e.querySelector(`[data-header-menu-id="${n}"]`);if(!d)return;let p=d.id,u=e.querySelector(`[aria-controls="${p}"]`);u==null||u.click()},c=()=>{let n=e.querySelector("[data-header-drawer-nav]"),d=n==null?void 0:n.querySelectorAll("details"),p=(u,h,b)=>{!u||!h||!b||(u.classList.remove("open"),b.addEventListener("transitionend",function S($){$.propertyName==="grid-template-rows"&&(u.removeAttribute("open"),h.setAttribute("aria-expanded",!1),b.removeEventListener("transitionend",S))}))};d==null||d.forEach(u=>{let h=u.querySelector("summary"),b=h==null?void 0:h.nextElementSibling;!h||!b||h.addEventListener("click",S=>{var I;S.preventDefault();let $=u.classList.contains("open"),k=(I=h.closest("[data-menu-drawer-menu]"))==null?void 0:I.querySelector("details.open");if(k&&k!==u){let L=k.querySelector("summary"),P=L==null?void 0:L.nextElementSibling;p(k,L,P)}$?p(u,h,b):(u.setAttribute("open",!0),h.setAttribute("aria-expanded",!0),requestAnimationFrame(()=>{u.classList.add("open"),k&&setTimeout(()=>{let L=u.getBoundingClientRect();L.top>=0&&L.top<=window.innerHeight||u.scrollIntoView({behavior:"smooth"})},350)}))})})};s.matches&&(a(),c(),i=!0),s.addEventListener("change",n=>{!n.matches||i||(t(),a(),c())})},St=Vt;var Nt=({sdkUrl:e,serverUrl:t,clientCode:s,apiKey:i,storeId:a})=>e&&t&&s&&i&&a,Dt=({enable:e=!1})=>e,Ut=({enable:e,serverUrl:t,clientCode:s,apiKey:i,storeId:a})=>{var d,p,u,h;if(!e||!t||!s||!i||!a)return;let c=(d=window.theme.locale.isoCode)!=null?d:"en",n=(p=window.theme.localization.country)!=null?p:"NZ";window.Tagalys.setConfiguration({api:{serverUrl:t,credentials:{clientCode:s,apiKey:i},storeId:a},locale:`${c}-${n}`,currency:{displayFormatter:"{{currencyLabel}}{{value}}",code:(u=window.theme.localization.currency)!=null?u:"NZD",label:(h=window.theme.localization.currencySymbol)!=null?h:"$",fractionalDigits:2,forceFractionalDigits:!0},analyticsStorageConsentProvided(){return!0},track:!0})},jt=({enable:e,storefrontApiAccessToken:t})=>{var i,a;if(!e)return;let s=[{namespace:"card",key:"badge"},{namespace:"card",key:"message"}];window.Tagalys.setPlatformConfiguration({platform:"Shopify",countryCode:(i=window.theme.localization.country)!=null?i:"NZ",baseCountryCode:(a=window.theme.localization.baseCountry)!=null?a:"NZ",useStorefrontAPIForSecondaryMarkets:!!t,waitForStorefrontAPI:!!t,storefrontAPI:{accessToken:t,myShopifyDomain:window.Shopify.shop},metafields:{products:s}})},B=e=>{let t=setInterval(()=>{if(!window.Tagalys||!window.tagalysReady){window.console.error("TWP | onTagalysReady | Tagalys is not ready");return}clearInterval(t),typeof e=="function"&&e()},150)},Lt=()=>{let e=window.theme.tagalys;if(!e||!Nt(e)||!Dt(e))return;let t=setInterval(()=>{if(!window.Tagalys){window.console.error("TWP | tagalysInit | Tagalys has not loaded");return}clearInterval(t),Ut(window.theme.tagalys),jt(window.theme.tagalys),window.tagalysReady=!0,document.dispatchEvent(new Event("tagalys:ready"))},150)};var xt=e=>{let t=window.theme.locale.rootUrl==="/"?"":window.theme.locale.rootUrl;return`${window.location.origin}${t}/products/${e.handle}`},G=e=>{if(!e)return"";let t=document.createElement("textarea");return t.innerHTML=e,t.value};var J=(e,t,s,i)=>{if(!e||!(t||s)||t&&typeof t!="number"||s&&typeof s!="number"||i&&typeof i!="string")return null;try{let a=new URL(e,window.location.origin),c=a.searchParams,n=c.get("width"),d=c.get("height"),p=c.get("crop");return!s&&d&&c.delete("height"),!t&&n&&c.delete("width"),!i&&p&&c.delete("crop"),t&&c.set("width",t),s&&c.set("height",s),i&&c.set("crop",i),a.href}catch(a){return null}};var Qt=(e,t,s,i=!0,a="")=>{let c=[160,320,480,640,800,960,1120,1280,1440,1600,1920,2240,2560],n="";return c.forEach((d,p)=>{if(d>s)return;let u=J(e.src,d);p>0&&(n+=", "),n+=`${u} ${d}w`}),`
    <img
      class="component-image__image"
      src="${J(e.src,480)}"
      srcset="${n}"
      loading="${i?"lazy":"eager"}"
      sizes="${a}"
      width="${e.width}"
      height="${e.height}"
      alt="${t}"
    />`},V=Qt;var Zt=(e,t)=>{var S,$,k;let s="2-3",i="1120",a="(min-width: 61.875rem) 26.5vw, (min-width: 48rem) 35vw, 90vw",c=e.title,n=($=(S=window.theme)==null?void 0:S.productCard)==null?void 0:$.showSecondaryImages,d=e.images,p=d[0],u=(k=p==null?void 0:p.alt)!=null?k:c,h=d.length>1?`${V(p,u,i,!0,a,s)}
    ${V(d[1],u,i,!0,a,s)}`:`
    ${V(p,u,i,!0,a,s)}`,b="";if(n&&e.images.length>1){let I="";e.images.forEach((L,P)=>{var R;if(P===0)return;let M=(R=L.alt)!=null?R:c;I+=`<div class="product-card__slide"><a href=${t}>${V(L,M,i,!0,a,s)}</a></div>`}),b=`<div class="product-card__slider" data-slider>
      <div class="product-card__slide">${h}</div>
      ${I}
    </div>`}return b||h},It=Zt;var Ct=e=>{var s,i,a;let t=(s=e.tags)==null?void 0:s.some(c=>c.toLowerCase()==="notify-me");return((a=(i=window.theme)==null?void 0:i.notifyMe)==null?void 0:a.enable)&&t},K=e=>{var t;return(t=e.options_with_values)==null?void 0:t.find(s=>s.name==="Size")},Gt=e=>{var a,c,n;let t=K(e),s=Ct(e),i=((n=(c=(a=window.theme)==null?void 0:a.strings)==null?void 0:c.product)==null?void 0:n.oneSize)||"One Size";if(!t){let d=e.variants[0],p=!d.available;return`
      <button
        class="quick-add-inline-desktop__size-btn ${p?"quick-add-inline-desktop__size-btn--sold-out":""}"
        data-variant-id="${d.id}"
        data-size="${i}"
        data-product-id="${e.id}"
        type="button"
        ${p&&!s?'disabled aria-disabled="true"':""}
        ${p&&s?`data-notify-me-trigger data-variant-id-notify="${d.id}"`:""}
        aria-label="${p&&s?`Notify me when ${i} is back in stock`:`Add ${i} to cart`}"
      >
        <span class="quick-add-inline-desktop__size-text${p&&s?" quick-add-inline-desktop__size-text--strikethrough":""}">${i}</span>
        ${p&&s?`
          <span class="quick-add-inline-desktop__notify-icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
              <rect x="3.92857" y="4.42857" width="9.14286" height="7.14286" stroke="#B8B9BA" stroke-width="0.857143"/>
              <path d="M3.75 5.42859C4.15 5.42859 7.16667 7.42859 8.5 8.28573L13.25 5.42859" stroke="#B8B9BA" stroke-width="0.857143"/>
            </svg>
          </span>
        `:'<span class="quick-add-inline-desktop__success-icon" aria-hidden="true">\u2713</span>'}
      </button>
    `}return t.values.map(d=>{let p=e.variants.find(h=>h.option1===d||h.option2===d||h.option3===d);if(!p)return"";let u=!p.available;return`
      <button
        class="quick-add-inline-desktop__size-btn ${u?"quick-add-inline-desktop__size-btn--sold-out":""}"
        data-variant-id="${p.id}"
        data-size="${d}"
        data-product-id="${e.id}"
        type="button"
        ${u&&!s?'disabled aria-disabled="true"':""}
        ${u&&s?`data-notify-me-trigger data-variant-id-notify="${p.id}"`:""}
        aria-label="${u&&s?`Notify me when size ${d} is back in stock`:`Add size ${d} to cart`}"
      >
        <span class="quick-add-inline-desktop__size-text${u&&s?" quick-add-inline-desktop__size-text--strikethrough":""}">${d}</span>
        ${u&&s?`
          <span class="quick-add-inline-desktop__notify-icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
              <rect x="3.92857" y="4.42857" width="9.14286" height="7.14286" stroke="#B8B9BA" stroke-width="0.857143"/>
              <path d="M3.75 5.42859C4.15 5.42859 7.16667 7.42859 8.5 8.28573L13.25 5.42859" stroke="#B8B9BA" stroke-width="0.857143"/>
            </svg>
          </span>
        `:'<span class="quick-add-inline-desktop__success-icon" aria-hidden="true">\u2713</span>'}
      </button>
    `}).join("")},Jt=(e,t)=>{var n,d,p,u;let s=K(e),i=Ct(e),a=((p=(d=(n=window.theme)==null?void 0:n.strings)==null?void 0:d.product)==null?void 0:p.oneSize)||"One Size",c={id:e.id,title:e.title,vendor:e.vendor,price:t.formatCurrency(e.price),compareAtPrice:e.compare_at_price?t.formatCurrency(e.compare_at_price):null,handle:e.handle,aspectRatio:2/3,images:((u=e.images)==null?void 0:u.slice(0,5).map(h=>({url:h.src,srcset:`${h.src}?w=250 250w, ${h.src}?w=500 500w, ${h.src}?w=750 750w, ${h.src}?w=1000 1000w`,alt:h.alt||"",width:h.width,height:h.height})))||[],sizes:s?s.values.map(h=>{let b=e.variants.find(S=>S.option1===h||S.option2===h||S.option3===h);return b?{value:h,variantId:b.id,available:b.available}:null}).filter(Boolean):[{value:a,variantId:e.variants[0].id,available:e.variants[0].available}],variants:e.variants.map(h=>({id:h.id,title:h.title,available:h.available})),notifyMeEnabled:i};return`
    <button
      class="quick-add-inline-mobile__trigger"
      aria-label="Quick add ${e.title}"
      data-quick-add-trigger
      data-product-id="${e.id}"
      data-product-json='${JSON.stringify(c).replace(/'/g,"&#39;")}'
      type="button"
    >
      <svg class="icon icon--plus" viewBox="0 0 24 24" width="24" height="24">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.6 5H11.4V11.4H5V12.6H11.4V19H12.6V12.6H19V11.4H12.6V5Z" fill="currentColor"/>
      </svg>
    </button>
  `},Kt=(e,t)=>{var p,u;if(!((u=(p=window.theme)==null?void 0:p.quickAdd)!=null&&u.enable)||!e.variants||e.variants.length===0)return"";let s=K(e),i=s?s.values.length:1,a=!1,c=!1,n=!1;s&&s.values.forEach(h=>{h.length>=7?(n=!0,c=!0,a=!0):h.length>=6?(c=!0,a=!0):h.length>=4&&(a=!0)});let d="";return i===1?d=" quick-add-inline-desktop__sizes--one-size":n?d=" quick-add-inline-desktop__sizes--two-columns":i<=3?d=" quick-add-inline-desktop__sizes--flex":i===4&&c?d=" quick-add-inline-desktop__sizes--three-columns":i===4?d=" quick-add-inline-desktop__sizes--flex":a&&i===5?d=" quick-add-inline-desktop__sizes--three-columns":a&&i>5&&(d=" quick-add-inline-desktop__sizes--four-columns"),`
    <quick-add-inline
      class="quick-add-inline"
      data-product-id="${e.id}"
      data-section-id="tagalys-${e.id}"
    >
      <div class="quick-add-inline__desktop small-hide">
        <div class="quick-add-inline-desktop">
          <div class="quick-add-inline-desktop__sizes${d}">
            ${Gt(e)}
          </div>
        </div>
      </div>
      <div class="quick-add-inline__mobile medium-up-hide">
        ${Jt(e,t)}
      </div>
    </quick-add-inline>
  `},Yt=e=>{var s;if(!(e!=null&&e.length))return"";let t=e.filter(i=>i.includes("label:"));return t.length===0?"":`
    <div class="card__badge ${(s=window.theme)==null?void 0:s.badgePosition}">
      ${t.map(i=>`<span class="badge">${i.replace("label:","")}</span>`).join("")}
    </div>
  `},Xt=e=>{var s,i;if(!((i=(s=window.theme)==null?void 0:s.wishlist)!=null&&i.twpEnable))return"";let t=e;return t.featured_image=e.images[0].src,`
    <div class="osc-css wrapper-button-collection">
      <div
        class="button-collection-wishlist button-${e.id}"
        data-product-id="${e.id}"
        data-has-only-variant="${e.has_only_default_variant}"
        data-product-title="${e.title}"
      >
        <span class="button-icon"></span>
        <span class="button-text"></span>
      </div>
    </div>
    <script type="application/json" id="ProductJson-${e.id}">
      ${JSON.stringify(e)}
    <\/script>
    <script type="application/json" id="OptionJson-${e.id}">
      ${JSON.stringify(e.options_with_values)}
    <\/script>
  `},es=e=>{var t,s;return(s=(t=e==null?void 0:e.card)==null?void 0:t.message)!=null&&s.value?`<div class="card__message caption">${e.card.message.value}</div>`:""},ts=e=>e?`
    <span class="visually-hidden">Vendor</span>
    <div class="caption-with-letter-spacing">${e}</div>
  `:"",ss=(e,t,s,i)=>{var n,d,p,u,h,b;let a=t.isProductOnSale(i,s);return e.price_varies?`
      <span>
        ${(((p=(d=(n=window.theme)==null?void 0:n.strings)==null?void 0:d.product)==null?void 0:p.priceFrom)||"From {{ price }}").replace("{{ price }}",t.formatCurrency(e.price_min||s))}
      </span>
    `:`
    ${a?`
    <span class="visually-hidden">${((b=(h=(u=window.theme)==null?void 0:u.strings)==null?void 0:h.product)==null?void 0:b.regularPrice)||"Regular price"}</span>
    <s data-compare-price>${t.formatCurrency(i)}</s>
  `:""}
    <span data-product-price ${a?'class="product-card__sale-price"':""}>
      ${t.formatCurrency(s)}
    </span>
  `},is=(e,t)=>{let i=t.getTemplateOptions("product").productPageUrl(e),a=t.getPrice?t.getPrice(e):e.price,c=t.getCompareAtPrice?t.getCompareAtPrice(e):e.compare_at_price,n=t.isProductOnSale(e.compare_at_price,e.price);return`
    <div class="card-wrapper product-card-wrapper underline-links-hover product-card-wrapper-TWP">
      ${Xt(e)}
      <div class="card card--standard card--media" style="--ratio-percent: 128.47826086956522%">
        <div class="card__inner color-scheme-2 gradient ratio" style="--ratio-percent: 128.47826086956522%">
          <a href=${i} class="card__content full-unstyled-link">
            <div class="card__media">
              <div class="media media--transparent ${e.images.length>1?"media--hover-effect":""}">
                ${It(e,i)}
                <span class="visually-hidden">${e.title}</span>
              </div>
            </div>
            ${Yt(e.tags)}
          </a>
          ${Kt(e,t)}
        </div>
        <div class="card__content">
          <div class="card__information">
            ${ts(e.vendor)}
            <h3 class="card__heading">
              <a class="full-unstyled-link" href=${i}>${e.title}</a>
            </h3>
            <div class="card-information">
              <span class="caption-large light"></span>
              <div class="price ${n?"price--on-sale":""}">
                <div class="price__container">
                  ${ss(e,t,a,c)}
                </div>
              </div>
              ${es(e.metafields)}
            </div>
          </div>
        </div>
      </div>
    </div>
  `},D=is;var as=(e,t)=>{var d,p,u,h,b,S;let s=(d=t==null?void 0:t.dataset)==null?void 0:d.sectionId,i=(p=t==null?void 0:t.dataset)==null?void 0:p.title,a=(h=(u=t==null?void 0:t.dataset)==null?void 0:u.headingSize)!=null?h:"h5",c=(b=t==null?void 0:t.dataset)==null?void 0:b.buttonLabel,n=(S=t==null?void 0:t.dataset)==null?void 0:S.buttonUrl;return{widget:{options:{limit:e,displayFormat:"grid",includeTagalysCSS:!1},render:($,k)=>{let I=k.props,P=I.helpers.getProducts();if(I.loading===!1)return P.length===0?null:$`
            <${k.templates.title} />
            <${k.templates.productList} />
            <${k.templates.button} />
          `}},title:{render:$=>i?$`
            <div class="product-recommendations__title">
              <h2 class="title inline-richtext ${a}">${i}</h2>
            </div>
          `:$``},productList:{render:($,k)=>$`
        <slider-component class="slider-component-full-width">
          <${k.templates.products} />
          <${k.templates.carouselActions} />
        </slider-component>
      `},products:{render:($,k)=>{let L=k.props.helpers.getProducts();return $`<ul
          id="Slider-${s}"
          class="grid product-grid contains-card contains-card--product contains-card--standard grid--4-col-desktop grid--2-col-tablet-down slider slider--desktop slider--tablet grid--peek"
        >
          ${L.map((P,M)=>$`<li class="grid__item slider__slide scroll-trigger animate--slide-in">
                <${k.templates.product} key=${M} product=${P} />
              </li>`)}
        </ul> `}},product:{options:{productPageUrl($){return xt($)}},render:($,k)=>{let I=k.props,L=I.product,P=I.helpers;return $`<div
          class="tagalys-section__slide"
          id="Slide-${L.id}"
          dangerouslySetInnerHTML=${{__html:D(L,P)}}
        />`}},carouselActions:{render:$=>{var k,I,L,P,M,R;return $`
        <div class="slider-buttons">
          <button
            type="button"
            class="slider-button slider-button--prev"
            name="previous"
            aria-label="${(L=(I=(k=window.theme)==null?void 0:k.strings)==null?void 0:I.accessibility)==null?void 0:L.previousSlide}"
            aria-controls="Slider-${s}"
          >
            <span class="svg-wrapper">
              <svg
                class="icon icon--arrow-right"
                aria-label="Icon arrow right"
                width="8"
                height="9"
                viewBox="0 0 8 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 4.43945H7" stroke="currentColor"></path>
                <path d="M3.28711 0.787109L7.00015 4.50015L3.28711 8.2132" stroke="currentColor"></path>
              </svg>
            </span>
          </button>
          <button
            type="button"
            class="slider-button slider-button--next"
            name="next"
            aria-label="${(R=(M=(P=window.theme)==null?void 0:P.strings)==null?void 0:M.accessibility)==null?void 0:R.nextSlide}"
            aria-controls="Slider-${s}"
          >
            <span class="svg-wrapper">
              <svg
                class="icon icon--arrow-right"
                aria-label="Icon arrow right"
                width="8"
                height="9"
                viewBox="0 0 8 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 4.43945H7" stroke="currentColor"></path>
                <path d="M3.28711 0.787109L7.00015 4.50015L3.28711 8.2132" stroke="currentColor"></path>
              </svg>
            </span>
          </button>
        </div>
      `}},button:{render:$=>c&&n?$`
            <div class="product-recommendations__button">
              <a href="${n}" class="button button--secondary">${c}</a>
            </div>
          `:$``}}},U=as;var rs={widget:'[data-tagalys-widget="recommendations"]'},ns=e=>{var a,c,n,d,p,u,h;let t=(a=e==null?void 0:e.dataset)==null?void 0:a.recommendationId,s=(c=e==null?void 0:e.dataset)==null?void 0:c.productId,i=(d=(n=e==null?void 0:e.dataset)==null?void 0:n.limit)!=null?d:8;if(!t||!s){window.console.error("TWP | tagalysSimilarProducts | recommendationId or productId is missing");return}(h=(u=(p=window.Tagalys)==null?void 0:p.UIWidgets)==null?void 0:u.Recommendations)==null||h.init(rs.widget,{recommendationId:t,productId:s,templates:U(i,e),callbacks:{afterInitialRender:()=>{let b=e.querySelector("slider-component");b==null||b.reinitialiseSlider()}}})},Pt=e=>{B(()=>ns(e))};var ls="product-recommendations-recently",os={tagalysWidget:'[data-tagalys-widget="recommendations"]',prevButton:"[data-prev-btn]",nextButton:"[data-next-btn]",recommendedWrapper:"[data-recommended-wrapper]",recommendedSliderContainer:"[data-recommended-slider]",productCard:"[data-product-card]",sliderDesktop:".slider--desktop"},Y=e=>{let s=e.querySelector(`[data-section-type="${ls}"]`).querySelector(os.tagalysWidget);s&&Pt(s)};var X={searchInput:"[data-TWP-search-input]",featuredProductsWidget:'[data-tagalys-widget="featured-products-suggestions"]'},Tt=(e,t)=>{let i=t.props.helpers.getProducts();return e`<div>
    <ul class="TWP-predictive-search__results-list--products predictive-search__results-list list-unstyled">
      ${i.map(a=>e`
          <li class="predictive-search__list-item">
            <${t.templates.product} key=${a.id} product=${a} />
          </li>
        `)}
    </ul>
  </div>`},Mt=(e,t)=>{var p,u,h,b,S,$,k,I,L;let s=t.props,i=s.product,a=s.helpers,n=a.getTemplateOptions("product").productPageUrl(i),d=i.tags?(p=i.tags)==null?void 0:p.filter(P=>P.includes("label:")):[];return e`
    <a
      href=${n}
      class="predictive-search__item predictive-search__item--link-with-thumbnail link link--text product-card-wrapper-TWP"
    >
      ${i.featured_image?e`<img
            class="predictive-search__image"
            src="${i.featured_image.src}&width=340"
            srcset="
              ${i.featured_image.src}&width=160   160w,
              ${i.featured_image.src}&width=360   360w,
              ${i.featured_image.src}&width=533   533w,
              ${i.featured_image.src}&width=720   720w,
              ${i.featured_image.src}&width=940   940w,
              ${i.featured_image.src}&width=1066 1066w,
              ${i.featured_image.src}&width=2132 2132w
            "
            sizes="(min-width: 768px) 25vw, 30vw"
            width="${i.featured_image.width}"
            height="${i.featured_image.height}"
            alt="${(u=i.featured_image.alt)!=null?u:i.title}"
          />`:null}

      <div class="predictive-search__item-content">
        <span class="visually-hidden">${(S=(b=(h=window.theme)==null?void 0:h.strings)==null?void 0:b.accessibility)==null?void 0:S.vendor}</span>
        <div class="predictive-search__item-vendor caption-with-letter-spacing">${i.vendor}</div>

        <p class="predictive-search__item-heading paragraph--small">${i.title}</p>

        ${a.isProductOnSale(i.compare_at_price,i.price)?e`
              <p class="price price--on-sale">
                <div class="price__sale">
                  <span class="visually-hidden">${(k=($=window.theme)==null?void 0:$.strings)==null?void 0:k.regularPriceLabel}</span>
                  <s class="price-item price-item--regular">
                    ${a.formatCurrency(i.compare_at_price)}
                  </s>
                  <span class="visually-hidden">${(L=(I=window.theme)==null?void 0:I.strings)==null?void 0:L.salePriceLabel}</span>
                  <span class="price-item price-item--sale price-item--last">
                    ${a.formatCurrency(i.price)}
                  </span>
                </div>
              </p>
            `:e`
              <p class="price">
                <div class="price__regular">
                  <span class="price-item price-item--regular">${a.formatCurrency(i.price)}</span>
                </div>
              </p>
            `}
      </div>

      ${d.length>0?e`
            <div class="card__badge">
              ${d.map(P=>{let M=P.replace("label:","");return e`<span class="badge">${M}</span>`})}
            </div>
          `:""}
    </a>
  `},Ft=()=>{B(()=>{var s,i,a;if(!document.querySelector(X.searchInput))return;let t=window.theme.locale&&!window.theme.locale.primary?window.theme.locale.rootUrl:"";(a=(i=(s=window.Tagalys)==null?void 0:s.UIWidgets)==null?void 0:i.SearchSuggestions)==null||a.init(X.searchInput,{searchResultsURL:`${t}${window.theme.routes.search}`,templates:{widget:{options:{includeTagalysCSS:!1,request:{products:{limit:3},collections:{limit:5},pages:{limit:5}},inheritAlignmentElementWidth:!1,position(c,n){let d=c.parentElement,p=n.parentElement;return d.after(p),!1}}},hint:{render(c){return c``}},clickSuggestions:{render(c,n){var S,$,k,I,L,P;let p=n.props.helpers,u=p.getRecentAndPopularSearches(),h=u.recentSearches,b=u.popularSearches;return c`
              <div class="predictive-search__results-groups-wrapper">
                <div class="predictive-search__result-group">
                  ${h.length>0?c`
                        <div>
                          <h2 class="predictive-search__heading text-body caption-with-letter-spacing">
                            ${(k=($=(S=window.theme)==null?void 0:S.strings)==null?void 0:$.search)==null?void 0:k.recentSearches}
                          </h2>
                          <ul class="predictive-search__results-list list-unstyled">
                            ${h.map(M=>c`
                                <li>
                                  <a
                                    href=${p.getLink(M.queryString)}
                                    class="predictive-search__item link link--text"
                                  >
                                    <span
                                      class="predictive-search__item-heading predictive-search__item-query-result paragraph--small"
                                    >
                                      ${M.displayString}
                                    </span>
                                  </a>
                                </li>
                              `)}
                          </ul>
                        </div>
                      `:null}
                  ${b.length>0?c`
                        <div>
                          <h2 class="predictive-search__heading text-body caption-with-letter-spacing">
                            ${(P=(L=(I=window.theme)==null?void 0:I.strings)==null?void 0:L.search)==null?void 0:P.popularSearches}
                          </h2>
                          <ul class="predictive-search__results-list list-unstyled">
                            ${b.map(M=>c`
                                <li>
                                  <a
                                    href=${p.getLink(M.queryString)}
                                    class="predictive-search__item link link--text"
                                  >
                                    <span
                                      class="predictive-search__item-heading predictive-search__item-query-result paragraph--small"
                                    >
                                      ${M.displayString}
                                    </span>
                                  </a>
                                </li>
                              `)}
                          </ul>
                        </div>
                      `:null}
                </div>
                <div class="predictive-search__result-group">
                  <${n.templates.featuredProductsSuggestions} />
                </div>
              </div>
            `}},featuredProductsSuggestions:{render(c){return c`<div
              className="featured-products-suggestions featured_products-wrapper"
              data-tagalys-widget="featured-products-suggestions"
            ></div>`},callbacks:{afterInitialRender:()=>{var n,d;let c=(d=(n=window.theme)==null?void 0:n.tagalys)==null?void 0:d.featuredProductsWidget.id;c&&window.Tagalys.UIWidgets.SmartWidget.init(X.featuredProductsWidget,{widgetId:c,templates:{widget:{options:{limit:3,displayFormat:"grid",includeTagalysCSS:!1},render:(p,u)=>{let h=u.props,S=h.helpers.getProducts();if(h.loading===!1)return S.length===0?null:p` <${u.templates.products} /> `}},products:{render:(p,u)=>Tt(p,u)},product:{render(p,u){return Mt(p,u)}}}})}}},typeSuggestions:{render(c,n){var $,k,I,L,P,M,R,x,O,A,E,H;let d=n.props,p=d.helpers,u=p.getAPIResponse(),h=(k=($=u==null?void 0:u.metadata)==null?void 0:$.products)==null?void 0:k.total,b=d.helpers.getEnteredSearchQuery(),S=`${t}${window.theme.routes.search}?q=${b}`;return c`
              <div class="predictive-search__results-groups-wrapper">
                <!--------- TEXT SUGGESTIONS (collections and pages) --------->
                <div class="predictive-search__result-group">
                  ${p.hasTextSearchSuggestions()?c` <${n.templates.textSuggestions} /> `:null}
                </div>

                <!--------- PRODUCTS SUGGESTIONS --------->
                <div class="predictive-search__result-group">
                  <${n.templates.products} />
                </div>
              </div>

              <div class="predictive-search__search-for-button">
                ${h?c`
                      <p class="predictive-search__results-count caption-with-letter-spacing hide--max-md">
                        ${h===1?(M=(P=(L=(I=window.theme)==null?void 0:I.strings)==null?void 0:L.search)==null?void 0:P.resultsWithCount.one)==null?void 0:M.replace("{{ count }}",h):(O=(x=(R=window.theme)==null?void 0:R.strings)==null?void 0:x.search)==null?void 0:O.resultsWithCount.other.replace("{{ count }}",h)}
                      </p>
                    `:null}

                <a
                  href=${encodeURI(S)}
                  class="predictive-search__item predictive-search__item--term button button--primary animate-arrow"
                >
                  <span data-predictive-search-search-for-text>${(H=(E=(A=window.theme)==null?void 0:A.strings)==null?void 0:E.search)==null?void 0:H.view_all}</span>
                </a>
              </div>
            `}},textSuggestions:{render(c,n){let u=n.props.helpers.getTextSuggestions();return c`
              ${u.map(h=>{var b;return c`
                  <div>
                    <h2 class="predictive-search__heading text-body caption-with-letter-spacing">
                      ${h.section_title}
                    </h2>
                    <ul class="predictive-search__results-list list-unstyled">
                      ${(b=h.items)==null?void 0:b.map(S=>c`
                          <li class="predictive-search__list-item">
                            <a href=${S.link} class="predictive-search__item link link--text" tabindex="-1">
                              <span
                                class="predictive-search__item-heading predictive-search__item-query-result paragraph--small"
                              >
                                ${S.displayString}
                              </span>
                            </a>
                          </li>
                        `)}
                    </ul>
                  </div>
                `})}
            `}},products:{render(c,n){return Tt(c,n)}},product:{render(c,n){return Mt(c,n)}}},callbacks:{afterInitialRender:()=>{let c=document.querySelector(".section-header"),n=document.querySelector(".tagalys-search-suggestions");if(!c||!n)return;let d=window.innerHeight-c.getBoundingClientRect().bottom;n.style.maxHeight=`${d}px`}}})})};var j={widget:'[data-tagalys-widget="search-results"]',drawer:"[data-filters-drawer]",facetsVertical:"[data-facets-vertical]"},cs=e=>{var S,$,k,I,L,P,M,R,x,O,A,E,H,te,se,ie,ae,re,ne,le,oe,ce,de,pe,ue,he,me,fe,ve,ge,be,ye,_e,we,$e,ke,Se,Le,xe,Ie,Ce,Pe,Te,Me,Fe,Ae,qe,Oe,Ee,Re,ze,Be,We,He,Ve,Ne,De,Ue,je,Qe,Ze,Ge,Je,Ke,Ye,Xe,et,tt,st,it,at,rt,nt,lt,ot,ct,dt,pt,ut,ht,mt,ft,vt,gt,bt,yt,_t,wt;let t=e.querySelector(j.widget);if(!t)return;let s=window.matchMedia("(min-width: 990px)").matches,i=(S=t.dataset.limit)!=null?S:24,a=($=t.dataset)==null?void 0:$.noResultsWidget,c=(k=t.dataset.noResultsWidgetLimit)!=null?k:4,n=(I=t.dataset.filtersType)!=null?I:"horizontal",d=t.dataset.showVerticalFilters==="true",p=(L=t.dataset.searchFilterLabel)==null?void 0:L.toLowerCase(),u=t.dataset.showFilterResultsCount==="true",h=(P=t.dataset.defaultExpandedFilters)!=null?P:"",b=s?10:5;(wt=(R=(M=window.Tagalys)==null?void 0:M.UIWidgets)==null?void 0:R.SearchResults)==null||wt.init(j.widget,{templates:{widget:{options:{limit:i,includeTagalysCSS:!1},labels:{searchResults:{heading:{standard:(O=(x=window.theme)==null?void 0:x.strings.search)==null?void 0:O.titleWithCount,corrected:(E=(A=window.theme)==null?void 0:A.strings.search)==null?void 0:E.titleCorrected,partialMatches:(te=(H=window.theme)==null?void 0:H.strings.search)==null?void 0:te.titlePartialMatches,noResults:(ie=(se=window.theme)==null?void 0:se.strings.search)==null?void 0:ie.noResults}},filters:{heading:(oe=(le=(ne=(re=(ae=window.theme)==null?void 0:ae.strings)==null?void 0:re.search)==null?void 0:ne.filters)==null?void 0:le.heading)!=null?oe:"Filter",selected:(he=(ue=(pe=(de=(ce=window.theme)==null?void 0:ce.strings)==null?void 0:de.search)==null?void 0:pe.filters)==null?void 0:ue.selected)!=null?he:"{{ count }} selected",maxPrice:(be=(ge=(ve=(fe=(me=window.theme)==null?void 0:me.strings)==null?void 0:fe.search)==null?void 0:ve.filters)==null?void 0:ge.maxPrice)!=null?be:"The highest price is {{ price }}",from:(ke=($e=(we=(_e=(ye=window.theme)==null?void 0:ye.strings)==null?void 0:_e.search)==null?void 0:we.filters)==null?void 0:$e.from)!=null?ke:"From",to:(Ce=(Ie=(xe=(Le=(Se=window.theme)==null?void 0:Se.strings)==null?void 0:Le.search)==null?void 0:xe.filters)==null?void 0:Ie.to)!=null?Ce:"To",reset:(Ae=(Fe=(Me=(Te=(Pe=window.theme)==null?void 0:Pe.strings)==null?void 0:Te.search)==null?void 0:Me.filters)==null?void 0:Fe.reset)!=null?Ae:"Reset",clear:(ze=(Re=(Ee=(Oe=(qe=window.theme)==null?void 0:qe.strings)==null?void 0:Oe.search)==null?void 0:Ee.filters)==null?void 0:Re.clear)!=null?ze:"Clear",clearFilter:(Ne=(Ve=(He=(We=(Be=window.theme)==null?void 0:Be.strings)==null?void 0:We.search)==null?void 0:He.filters)==null?void 0:Ve.clearFilter)!=null?Ne:"Remove",clearAll:(Ze=(Qe=(je=(Ue=(De=window.theme)==null?void 0:De.strings)==null?void 0:Ue.search)==null?void 0:je.filters)==null?void 0:Qe.clearAll)!=null?Ze:"Remove all",apply:(Xe=(Ye=(Ke=(Je=(Ge=window.theme)==null?void 0:Ge.strings)==null?void 0:Je.search)==null?void 0:Ke.filters)==null?void 0:Ye.apply)!=null?Xe:"Apply",label:(at=(it=(st=(tt=(et=window.theme)==null?void 0:et.strings)==null?void 0:tt.search)==null?void 0:st.filters)==null?void 0:it.label)!=null?at:"Filter",buttonLabel:(ct=(ot=(lt=(nt=(rt=window.theme)==null?void 0:rt.strings)==null?void 0:nt.search)==null?void 0:lt.filters)==null?void 0:ot.buttonLabel)!=null?ct:"Filter"},sortOptions:{label:(ut=(pt=(dt=window.theme)==null?void 0:dt.strings)==null?void 0:pt.search)==null?void 0:ut.sortBy},resultsWithCount:{one:(vt=(ft=(mt=(ht=window.theme)==null?void 0:ht.strings)==null?void 0:mt.search)==null?void 0:ft.resultsWithCount)==null?void 0:vt.one,other:(_t=(yt=(bt=(gt=window.theme)==null?void 0:gt.strings)==null?void 0:bt.search)==null?void 0:yt.resultsWithCount)==null?void 0:_t.other}},render(o,r){let f=r.props.helpers;return f.isInitialLoading()?o` <${r.templates.loader} /> `:f.hasNoSearchResults()&&!f.hasAnyFiltersApplied()?o` <${r.templates.noResults} /> `:n==="vertical"?o`
              <${r.templates.header} />

              <${r.templates.filtersVerticalCount} />

              <div class="facets-vertical">
                <${r.templates.filtersVertical} />

                <div class="product-grid-container" id="ProductGridContainer">
                  <div class="active-facets-TWP active-facets active-facets-desktop">
                    <${r.templates.appliedFilters} />
                  </div>
                  <div class="template-search__results collection TWP-collection" id="product-grid">
                    <${r.templates.products} />
                    <${r.templates.productListFooter} />
                  </div>
                </div>
              </div>
            `:o`
            <${r.templates.header} />
            <${r.templates.productListHeader} />
            <div class="product-grid-container" id="ProductGridContainer">
              <div class="template-search__results collection" id="product-grid">
                <${r.templates.products} />
                <${r.templates.productListFooter} />
              </div>
            </div>
          `}},loader:{render(o){return o`
            <div class="loading__spinner">
              <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66">
                <circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path" />
              </svg>
            </div>
          `}},header:{render(o,r){return o`
            <div class="template-search__header page-width scroll-trigger animate--fade-in">
              <${r.templates.heading} />
            </div>
          `}},heading:{render(o,r){let l=r.props,f=r.labels,v=l.helpers;return o`<h1 class="h5 center">${(()=>{var y,_,w,C;let g;return v.getQuery()?v.hasNoSearchResults()&&!v.hasAnyFiltersApplied()?g=f.searchResults.heading.noResults.replace("{{ terms }}",v.getQuery()):v.isPartialResults()?g=f.searchResults.heading.partialMatches.replace("{{searchTerm}}",v.getQuery()):v.isSpellingCorrectedQuery()?g=f.searchResults.heading.corrected.replace("{{originalSearchTerm}}",v.getOriginalQuery()).replace("{{resultsCount}}",v.getTotalProductsCount()).replace("{{correctedSearchTerm}}",v.getQuery()):g=f.searchResults.heading.standard.replace("{{resultsCount}}",v.getTotalProductsCount()).replace("{{searchTerm}}",v.getQuery()):g=(C=(w=(_=(y=window.theme)==null?void 0:y.strings)==null?void 0:_.search)==null?void 0:w.search)!=null?C:"Search",G(g)})()}</h1>`}},productListHeader:{render(o,r){return o`
            <div id="main-search-filters" class="facets-wrapper facets-wrapper-TWP page-width">
              <div class="TWP-facets-container--horizontal facets-container scroll-trigger animate--fade-in">
                <!---------- DESKTOP FILTERS ---------->
                <div class="facets small-hide">
                  <div class="facets__form">
                    <${r.templates.filters} type="desktop" />
                    <${r.templates.sortOptions} type="dropdown" />
                    <div class="product-count light" role="status">
                      <h2 class="product-count__text text-body">
                        <${r.templates.resultsCountLabel} />
                      </h2>
                    </div>
                  </div>
                </div>

                <!---------- MOBILE FILTERS ---------->
                <${r.templates.mobileFiltersContainer} />
              </div>
              <div class="active-facets-TWP active-facets active-facets-mobile medium-hide large-up-hide">
                <${r.templates.appliedFilters} />
              </div>
            </div>
          `}},mobileFiltersContainer:{render(o,r){let l=r.labels;return o`
            <menu-drawer
              class="mobile-facets__wrapper medium-hide large-up-hide"
              data-breakpoint="mobile"
              data-filters-drawer
            >
              <details class="mobile-facets__disclosure disclosure-has-popup">
                <summary class="mobile-facets__open-wrapper focus-offset">
                  <span class="mobile-facets__open">
                    <${r.templates.icon} type="filters" />

                    <span
                      class="mobile-facets__open-label button-label medium-hide large-up-hide caption--strong"
                      dangerouslySetInnerHTML=${{__html:l.filters.label}}
                    >
                    </span>
                    <span class="mobile-facets__open-label button-label small-hide">${l.filters.buttonLabel}</span>
                  </span>
                  <span tabindex="0" class="mobile-facets__close">
                    <span class="svg-wrapper">
                      <${r.templates.icon} type="close" />
                    </span>
                  </span>
                </summary>
                <div class="facet-filters-form">
                  <div class="mobile-facets">
                    <div class="mobile-facets__inner gradient">
                      <div class="mobile-facets__header">
                        <div class="mobile-facets__header-inner">
                          <h2 class="mobile-facets__heading medium-hide large-up-hide caption--strong">
                            <${r.templates.icon} type="filters" />
                            <span dangerouslySetInnerHTML=${{__html:l.filters.label}}></span>
                          </h2>
                          <h2 class="mobile-facets__heading small-hide">${l.filters.buttonLabel}</h2>
                          <p class="mobile-facets__count"><${r.templates.resultsCountLabel} /></p>
                        </div>
                      </div>

                      <${r.templates.filters} type="mobile" />
                    </div>
                  </div>
                </div>
              </details>
            </menu-drawer>
          `},callbacks:{afterInitialRender:()=>{let o=t.querySelector(j.drawer);o==null||o.setAttribute("data-initialized","")}}},filtersVerticalCount:{render(o,r){var l,f,v,m,g,y,_,w,C,F;return o`
            <div class="facets facets-vertical-count small-hide">
              <div class="facets-vertical-form">
                <div class="product-count-vertical" role="status">
                  <h2 class="product-count__text">
                    <${r.templates.resultsCountLabel} />
                  </h2>
                </div>
                <facets-vertical-open>
                  <button
                    class="facets-vertical-open__btn btn-none"
                    type="button"
                    aria-expanded="${d?"true":"false"}"
                    data-facets-vertical-open
                  >
                    <${r.templates.icon} type="filters" />

                    <span class="facets-vertical-open__label facets-vertical-open__label--show caption--strong">
                      ${(g=(m=(v=(f=(l=window.theme)==null?void 0:l.strings)==null?void 0:f.search)==null?void 0:v.filters)==null?void 0:m.filterButtonShow)!=null?g:"Filter"}
                    </span>

                    <span class="facets-vertical-open__label facets-vertical-open__label--hide caption--strong">
                      ${(F=(C=(w=(_=(y=window.theme)==null?void 0:y.strings)==null?void 0:_.search)==null?void 0:w.filters)==null?void 0:C.filterButtonHide)!=null?F:"Filter"}
                    </span>
                  </button>
                </facets-vertical-open>
              </div>
            </div>
          `}},filtersVertical:{render(o,r){return o`
            <aside
              class="facets-wrapper facets-wrapper-TWP facets-wrapper-TWP--vertical${d?"":" facets-wrapper-TWP--vertical-hidden"}"
              data-facets-vertical
            >
              <div class="facets small-hide">
                <div class="facets__form-vertical">
                  <${r.templates.filters} type="desktop" />
                </div>
              </div>

              <${r.templates.mobileFiltersContainer} />
            </aside>
          `},callbacks:{afterInitialRender:()=>{t.querySelector(j.facetsVertical)&&document.dispatchEvent(new CustomEvent("tagalys-search:vertical-filters-ready"))}}},filters:{render(o,r){let l=r.props,f=r.labels,v=l.helpers,m=v.getFilters();if(l.type==="mobile")return o`
              <div id="FacetsWrapperMobile" class="mobile-facets__main has-submenu gradient">
                <${r.templates.sortOptions} type="list" device="mobile" />

                ${m.map((_,w)=>o`<${r.templates.filterMobile} filter=${_} index=${w+1} />`)}

                <div class="mobile-facets__footer">
                  <div class="mobile-facets__clear-wrapper">
                    <button
                      type="button"
                      class="mobile-facets__clear underlined-link"
                      onClick=${()=>v.clearAllFilters()}
                    >
                      ${f.filters.clearAll}
                    </button>
                  </div>

                  <button
                    type="button"
                    class="button button--primary"
                    onclick=${_=>{var w,C;(C=(w=_.target.closest(".mobile-facets__wrapper"))==null?void 0:w.querySelector("summary"))==null||C.click()}}
                  >
                    ${f.filters.apply}
                  </button>
                </div>
              </div>
            `;let g=m.some(_=>_.id==="_derived_field_in_stock"),y={id:"_derived_field_in_stock",name:"Available",type:"checkbox",items:[{id:"true",name:"In Stock",count:0,selected:!1}]};return o`
            <div id="FacetsWrapperDesktop" class="facets__wrapper">
              <h2 class="facets__heading caption-large text-body" id="verticalTitle" tabindex="-1">
                ${f.filters.heading}
              </h2>

              ${n==="vertical"?o` <${r.templates.sortOptions} type="list" device="desktop" />`:""}
              ${g?"":o`<${r.templates.filter} filter=${y} index=${0} />`}
              ${m.map((_,w)=>o`<${r.templates.filter} filter=${_} index=${w+1} />`)}
            </div>
            ${n!=="vertical"?o`
                  <div class="active-facets-TWP active-facets active-facets-desktop">
                    <${r.templates.appliedFilters} />
                  </div>
                `:""}
          `}},filterMobile:{render(o,r){var C,F,q;let l=r.props,f=r.labels,v=l.helpers,m=l.filter,g=l.index,y="";if(m.type==="range"){let T=v.labelFormatter(m.display_format,m.max,m.currency);y=f.filters.maxPrice.replace("{{ price }}",T)}let _=h.includes(m.name.toLowerCase()),w=n==="vertical"&&((C=m.items)==null?void 0:C.length)>b;return o`
            <details
              id="Details-Mobile-${m.id}-search"
              class="mobile-facets__details${_?" menu-opening":""}"
              data-index="mobile-${g}"
              open=${_}
            >
              <summary class="mobile-facets__summary focus-inset caption--strong">
                <div>
                  <span>${m.name}</span>
                  <span class="mobile-facets__arrow">
                    <${r.templates.icon} type="chevron-down" />
                  </span>
                </div>
              </summary>

              <div
                id="FacetMobile-${g}-search"
                class="mobile-facets__submenu gradient parent-display"
                data-facets-container
              >
                ${m.type==="range"?o` <p class="mobile-facets__info">${y}</p>
                      <${r.templates.rangeSliderFilterItem} filter=${m} />`:o`
                      <div class="parent-wrap">
                        ${n=="vertical"&&m.name.toLowerCase()===p?o` <${r.templates.filterSearch} filter=${m} /> `:""}
                        <ul
                          class="facets-layout facets-layout-list facets-layout-list--text mobile-facets__list list-unstyled"
                          role="list"
                        >
                          ${(F=m.items)==null?void 0:F.map((T,W)=>o`<${r.templates.filterItemMobile}
                                filterItem=${T}
                                index=${W+1}
                                filterId=${m.id}
                                hasShowMore=${w}
                              />`)}
                        </ul>
                      </div>
                      ${n==="vertical"&&((q=m.items)==null?void 0:q.length)>b?o` <${r.templates.showMoreButton} filterId=${m.id} /> `:""}
                    `}

                <div class="mobile-facets__footer gradient">
                  <div class="mobile-facets__clear-wrapper">
                    <button
                      type="button"
                      class="mobile-facets__clear underlined-link"
                      onClick=${()=>v.clearFilter(m.id)}
                    >
                      ${f.filters.clear}
                    </button>
                  </div>

                  <button
                    type="button"
                    class="button button--primary"
                    onclick=${T=>{var W,z;(z=(W=T.target.closest(".mobile-facets__wrapper"))==null?void 0:W.querySelector("summary"))==null||z.click()}}
                  >
                    ${f.filters.apply}
                  </button>
                </div>
              </div>
            </details>
          `}},filter:{render(o,r){var C,F,q;let l=r.props,f=r.labels,v=l.helpers,m=l.filter,g=l.index,y=(C=m.items)==null?void 0:C.filter(T=>T.selected).length,_=f.filters.selected.replace("{{ count }}",y);if(m.type==="range"){let T=v.labelFormatter(m.display_format,m.max,m.currency);_=f.filters.maxPrice.replace("{{ price }}",T)}let w=n==="vertical"&&h.includes(m.name.toLowerCase());if(m.id=="_derived_field_in_stock"){let T=(F=m.items)==null?void 0:F.find(z=>z.id==="true"),W=z=>{z.stopPropagation(),T.selected?v.clearFilter(m.id,T.id):v.applyFilter(m.id,T.id)};if(T){let z=T.selected?"availability-auto-applied":"";return o`
                <div class="facets__summary facets__summary--availability ${z} caption--strong">
                  <label class="facet-availablity__wrapper" onclick=${W}>
                    <span>${T.name}</span>

                    <div class="facet-availablity__switch">
                      <input
                        class="visually-hidden"
                        type="checkbox"
                        name="${m.id}"
                        value="${T.name}"
                        id="Filter-${m.id}-${T.value}"
                        checked=${T.selected}
                      />
                      <span class="facet-availability__switch-slider"></span>
                    </div>
                  </label>
                </div>
              `}}return o`
            <details
              id="Details-${m.id}-search"
              class="${n==="vertical"?"facets__disclosure-vertical":"facets__disclosure disclosure-has-popup"}"
              data-index="${g}"
              open=${w}
            >
              <summary class="facets__summary caption--strong focus-offset">
                <div>
                  <span class="facets__summary-label">${m.name}</span>
                  <${r.templates.icon} type="caret" />
                </div>
              </summary>

              <div
                id="Facet-${g}-search"
                class="parent-display ${n==="vertical"?"facets__display-vertical":"facets__display"}"
                data-facets-container
              >
                ${n!=="vertical"?o`
                      <div class="facets__header">
                        <div>
                          <span class="facets__selected">${_}</span>
                        </div>

                        <button
                          type="button"
                          class="facets__reset link underlined-link"
                          onClick=${()=>v.clearFilter(m.id)}
                        >
                          ${f.filters.reset}
                        </button>
                      </div>
                    `:""}
                ${n=="vertical"&&m.name.toLowerCase()===p?o`<${r.templates.filterSearch} filter=${m} />`:""}

                <${r.templates.filterItems} filter=${m} />

                ${n==="vertical"&&((q=m.items)==null?void 0:q.length)>b?o` <${r.templates.showMoreButton} filterId=${m.id} /> `:""}
              </div>
            </details>
          `}},filterSearch:{render(o,r){var f,v,m,g,y;let l=r.props.filter;return o`
            <facets-search class="facets-search">
              <input
                class="facets-search__input caption--strong"
                type="text"
                name="${l.param_name}-search"
                placeholder="Search"
                data-facets-search-input
              />
              <p class="facets-search__no-results hidden" data-facet-search-no-results>
                ${(y=(g=(m=(v=(f=window.theme)==null?void 0:f.strings)==null?void 0:v.search)==null?void 0:m.filters)==null?void 0:g.noResults)!=null?y:"No matching results"}
              </p>
            </facets-search>
          `}},filterItems:{render(o,r){var y,_;let l=r.props,f=r.labels,v=l.helpers,m=n==="vertical"&&((y=l.filter.items)==null?void 0:y.length)>b,g="";if(l.filter.type==="range"){let w=v.labelFormatter(l.filter.display_format,l.filter.max,l.filter.currency);g=f.filters.maxPrice.replace("{{ price }}",w)}if(l.filter.type==="checkbox")return o` <fieldset
              class="facets-wrap parent-wrap ${n==="vertical"?"facets-wrap-vertical":""}"
            >
              <legend class="visually-hidden">${l.filter.name}</legend>
              <ul
                class="facets-layout facets-layout-list facets-layout-list--text list-unstyled ${n==="vertical"?"facets__list--vertical":"facets__list"}"
                role="list"
              >
                ${(_=l.filter.items)==null?void 0:_.map((w,C)=>o`<${r.templates.filterItem}
                      filterItem=${w}
                      index=${C+1}
                      filterId=${l.filter.id}
                      hasShowMore=${m}
                    />`)}
              </ul>
            </fieldset>`;if(l.filter.type==="range")return o` ${n==="vertical"?o`<div class="facets__header-vertical">
                    <span class="facets__selected">${g}</span>
                  </div>`:""}
              <${r.templates.rangeSliderFilterItem} filter=${l.filter} />`}},filterItem:{render(o,r){let l=r.props,f=l.helpers,v=l.filterItem,m=`Filter-${l.filterId}-${l.index}`,g=y=>{var C;y.stopPropagation();let _=window.location.pathname!=="/collections/womens-coming-soon",w=l.filterId==="filter.v.m.custom.filtering_size"||l.filterId.toLowerCase().endsWith("size")&&!l.filterId.includes("prize");if(l.filterItem.selected)f.clearFilter(l.filterId,l.filterItem.id);else if(f.applyFilter(l.filterId,l.filterItem.id),w&&_){let F=f.getFilters().find(q=>q.id==="_derived_field_in_stock");if(F){let q=(C=F.items)==null?void 0:C.find(T=>T.id==="true");q&&!q.selected&&f.applyFilter("_derived_field_in_stock","true")}}};return o`<li
            class="list-menu__item facets__item${l.hasShowMore&&l.index>b?" show-more-item hidden":""}"
            data-facets-item
          >
            <label
              for=${m}
              class="facets__label facet-checkbox caption-with-letter-spacing"
              onclick=${g}
            >
              <input
                type="checkbox"
                name=${l.filterId}
                value=${v.name}
                id=${m}
                checked=${v.selected}
              />

              <${r.templates.icon} type="square" />

              <div class="svg-wrapper">
                <${r.templates.icon} type="checkmark" />
              </div>

              <span class="facet-checkbox__text" aria-hidden="true">
                <span class="facet-checkbox__text-label" data-facet-label>${v.name}</span>
                ${u?`(${v.count})`:""}
              </span>
            </label>
          </li>`}},filterItemMobile:{render(o,r){let l=r.props,f=l.helpers,v=l.filterItem,m=`Filter-${l.filterId}-${l.index}`,g=y=>{var C;y.stopPropagation();let _=window.location.pathname!=="/collections/womens-coming-soon",w=l.filterId==="filter.v.m.custom.filtering_size"||l.filterId.toLowerCase().endsWith("size")&&!l.filterId.includes("prize");if(l.filterItem.selected)f.clearFilter(l.filterId,l.filterItem.id);else if(f.applyFilter(l.filterId,l.filterItem.id),w&&_){let F=f.getFilters().find(q=>q.id==="_derived_field_in_stock");if(F){let q=(C=F.items)==null?void 0:C.find(T=>T.id==="true");q&&!q.selected&&f.applyFilter("_derived_field_in_stock","true")}}};return o`<li
            class="mobile-facets__item list-menu__item${l.hasShowMore&&l.index>b?" show-more-item hidden":""}"
            data-facets-item
          >
            <label
              for=${m}
              class="facets__label mobile-facets__label caption-with-letter-spacing"
              onclick=${g}
            >
              <input
                class="mobile-facets__checkbox"
                type="checkbox"
                name=${l.filterId}
                value=${v.name}
                id=${m}
                checked=${v.selected}
              />

              <span class="mobile-facets__highlight"></span>

              <${r.templates.icon} type="square" />

              <${r.templates.icon} type="checkmark" />

              <span class="facet-checkbox__text" aria-hidden="true">
                <span class="facet-checkbox__text-label" data-facet-label>${v.name}</span>
                ${u?`(${v.count})`:""}
              </span>
            </label>
          </li>`}},rangeSliderFilterItem:{render(o,r){var m,g,y,_;let l=r.props,f=r.labels,v=`Filter-${l.filter.name}-`;return o`
            <div class="facets__price">
              <div class="hide" ref=${l.sliderRef} />
              <span class="field-currency caption--strong">${(g=(m=window.theme)==null?void 0:m.localization)==null?void 0:g.currencySymbol}</span>
              <div class="field">
                <input
                  id=${`${v}-GTE`}
                  class="field__input"
                  type="number"
                  value=${l.sliderInputValues[0]}
                  onblur=${l.onInputBlur}
                  onchange=${l.onMinChange}
                />
                <label class="field__label caption--strong" for=${`${v}-GTE`}>${f.filters.from}</label>
              </div>
              <span class="field-currency caption--strong">${(_=(y=window.theme)==null?void 0:y.localization)==null?void 0:_.currencySymbol}</span>
              <div class="field">
                <input
                  id=${`${v}-LTE`}
                  class="field__input"
                  type="number"
                  value=${l.sliderInputValues[1]}
                  onblur=${l.onInputBlur}
                  onchange=${l.onMaxChange}
                />
                <label class="field__label caption--strong" for=${`${v}-LTE`}>${f.filters.to}</label>
              </div>
            </div>
          `}},appliedFilters:{render(o,r){let l=r.props,f=r.labels,v=l.helpers,m=v.getAppliedFilters(!0);return m.length?o`
            ${m.map(g=>{var y;return g.type==="range"?o`
                  <button
                    type="button"
                    class="active-facets__button active-facets__button--light btn-none"
                    onClick=${()=>v.clearFilter(g.id)}
                  >
                    <span class="active-facets__button-inner button button--tertiary">
                      ${v.labelFormatter(g.display_format,g.selected_min,g.currency)} -
                      ${v.labelFormatter(g.display_format,g.selected_max,g.currency)}
                      <span class="svg-wrapper">
                        <${r.templates.icon} type="close-small" />
                      </span>
                      <span class="visually-hidden">${f.filters.clearFilter}</span>
                    </span>
                  </button>
                `:(y=g.items)==null?void 0:y.map(_=>o`
                  <button
                    type="button"
                    class="active-facets__button active-facets__button--light btn-none"
                    onClick=${()=>v.clearFilter(g.id,_.id)}
                  >
                    <span class="active-facets__button-inner button button--tertiary">
                      ${_.name}
                      <span class="svg-wrapper">
                        <${r.templates.icon} type="close-small" />
                      </span>
                      <span class="visually-hidden">${f.filters.clearFilter}</span>
                    </span>
                  </button>
                `)})}

            <div class="active-facets__button-wrapper">
              <button
                type="button"
                class="active-facets__button active-facets__button-remove underlined-link btn-none"
                onClick=${()=>v.clearAllFilters()}
              >
                <span class="active-facets__button-inner">
                  ${f.filters.clearAll}
                  <span class="svg-wrapper">
                    <${r.templates.icon} type="close-small" />
                  </span>
                </span>
              </button>
            </div>
          `:""}},sortOptions:{render(o,r){let l=r.props,f=r.labels,v=l.helpers,m=v.getSortOptions(),g=v.getAppliedSortOption(),y=w=>{w.target.type==="radio"&&!w.target.checked||v.applySortOption(w.target.value)},_=h.includes(f.sortOptions.label.toLowerCase());if(l.type==="list")return o`
              <details
                id="${l.device==="desktop"?"Details-sortby-search":"Details-Mobile-SortBy-search"}"
                class="${l.device==="desktop"?"facets__disclosure-vertical":"mobile-facets__details menu-opening"}"
                open=${_}
              >
                <summary
                  class="${l.device==="desktop"?"facets__summary":"mobile-facets__summary"} focus-inset caption--strong"
                  aria-label="${f.sortOptions.label} ${g.label}"
                >
                  <div>
                    <span class="facets__summary-label">${f.sortOptions.label}</span>
                    ${l.device==="desktop"?o` <${r.templates.icon} type="caret" /> `:o`<span class="mobile-facets__arrow">
                          <${r.templates.icon} type="chevron-down" />
                        </span>`}
                  </div>
                </summary>

                <div class="${l.device==="desktop"?"facets__display-vertical":"mobile-facets__submenu"}">
                  <ul class="facets-layout facets-layout-list list-unstyled">
                    ${m.map(w=>o` <${r.templates.sortOptionListItem}
                          sortOption=${w}
                          applySortOption=${y}
                          device=${l.device}
                        />`)}
                  </ul>
                </div>
              </details>
            `;if(l.type==="dropdown")return o`
              <div class="facet-filters sorting caption">
                <div class="facet-filters__field">
                  <h2 class="facet-filters__label caption-large text-body">
                    <label for="SortBy">${f.sortOptions.label}</label>
                  </h2>
                  <div class="select">
                    <select
                      class="facet-filters__sort select__select caption-large"
                      id="SortBy"
                      name="sort_by"
                      value=${g.id}
                      onchange=${y}
                    >
                      ${m.map(w=>o` <option value=${w.id}>${w.label}</option>`)}
                    </select>

                    <span class="svg-wrapper">
                      <${r.templates.icon} type="chevron-down" />
                    </span>
                  </div>
                </div>
              </div>
            `}},sortOptionListItem:{render(o,r){let l=r.props,f=l.sortOption;return o`
            <li class="list-menu__item facets__item">
              <label
                for=${`SortBy-${f.id}-${l.device}`}
                class="facets__label facet-checkbox caption-with-letter-spacing"
              >
                <input
                  id=${`SortBy-${f.id}-${l.device}`}
                  class="visually-hidden"
                  type="radio"
                  name="sort_by"
                  value=${f.id}
                  ${f.selected?"checked":""}
                  onchange=${l.applySortOption}
                />
                <${r.templates.icon} type="square" />
                <div class="svg-wrapper">
                  <${r.templates.icon} type="checkmark" />
                </div>
                ${f.label}
              </label>
            </li>
          `}},resultsCountLabel:{render(o,r){let l=r.props,f=r.labels,m=l.helpers.getTotalProductsCount(),g=m===1?f.resultsWithCount.one:f.resultsWithCount.other,y=g==null?void 0:g.replace("{{ count }}",m);return o`${y}`}},products:{render(o,r){let v=r.props.helpers.getProducts();return o`
            <ul class="grid product-grid grid--2-col-tablet-down grid--4-col-desktop" role="list">
              ${v.map(m=>o`<${r.templates.product} key=${m.id} product=${m} />`)}
            </ul>
          `}},product:{render(o,r){let l=r.props,f=l.product,v=l.helpers;return o`<li
            class="grid__item scroll-trigger animate--slide-in"
            dangerouslySetInnerHTML=${{__html:D(f,v)}}
          />`}},productListFooter:{render(o,r){return o` <${r.templates.pagination} /> `}},pagination:{render(o,r){return o`
            <div class="pagination-wrapper">
              <nav class="pagination" role="navigation" aria-label="Pagination">
                <${r.templates.paginationLinks} />
              </nav>
            </div>
          `}},paginationLinks:{options:{showNumberedPageLinks:!0,numberedPageLinksWindowSize:3,showPreviousPageLink:!0,showFirstPageLink:!1,showNextPageLink:!0,scrollTop:!0},render(o,r){let l=r.props,f=l.helpers,v=f.getPagesToDisplay(l.numberedPageLinksWindowSize),m=f.hasPreviousPage(),g=f.hasNextPage();return o`
            <ul class="pagination__list list-unstyled" role="list">
              ${l.showPreviousPageLink&&m?o` <li>
                    <button
                      type="button"
                      class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce"
                      aria-label="Previous page"
                      onclick=${f.goToPreviousPage}
                    >
                      <span class="svg-wrapper">
                        <${r.templates.icon} type="caret" />
                      </span>
                    </button>
                  </li>`:null}
              ${l.showNumberedPageLinks?v.map(y=>{let _=["pagination__item link"],w=y.jumpAfter;y.current&&_.push("pagination__item--current");let C=_.join(" ");return w?o`
                        <li>
                          <span class="pagination__item tt">...</span>
                        </li>
                      `:o`
                      <li>
                        <button
                          type="button"
                          class=${`${C}`}
                          onclick=${()=>{f.goToPage(y.page)}}
                        >
                          ${y.page}
                        </button>
                      </li>
                    `}):null}
              ${l.showNextPageLink&&g?o`
                    <li>
                      <button
                        type="button"
                        class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce"
                        aria-label="Next page"
                        onclick=${f.goToNextPage}
                      >
                        <span class="svg-wrapper">
                          <${r.templates.icon} type="caret" />
                        </span>
                      </button>
                    </li>
                  `:null}
            </ul>
          `}},showMoreButton:{render(o,r){var f,v,m,g,y,_,w,C,F,q;let l=r.props;return o`<show-more-button>
            <button
              class="button-show-more link underlined-link caption--strong"
              id="Show-More-${l.filterId}-tagalys-search"
              type="button"
            >
              <span class="label-show-more label-text">
                ${(y=(g=(m=(v=(f=window.theme)==null?void 0:f.strings)==null?void 0:v.search)==null?void 0:m.filters)==null?void 0:g.showMore)!=null?y:"Show More"}
              </span>
              <span class="label-show-less label-text hidden">
                ${(q=(F=(C=(w=(_=window.theme)==null?void 0:_.strings)==null?void 0:w.search)==null?void 0:C.filters)==null?void 0:F.showLess)!=null?q:"Show Less"}
              </span>
            </button>
          </show-more-button>`}},noResults:{options:{widgets:[{widgetId:a,options:{templates:U(c,t),callbacks:{afterInitialRender:()=>{let o=t.querySelector("slider-component");o==null||o.reinitialiseSlider()}}}}]},render(o,r){return o`
            <${r.templates.header} />

            ${a?o`
                  <div class="product-recommendations__wrapper">
                    <${r.templates.noResultsWidgets} />
                  </div>
                `:""}
          `}},icon:{render(o,r){let l=r.props;if(l.type==="filters")return o`<svg
              class="icon icon-filters"
              xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="13"
              fill="none"
              viewBox="0 0 13 13"
            >
              <g fill="currentColor" clip-path="url(#a)">
                <path
                  fill-rule="evenodd"
                  d="M11.665.83H1.077v10.59h10.588V.83ZM.371.126v12h12v-12h-12Z"
                  clip-rule="evenodd"
                />
                <path
                  d="M3.444 4.949h4.197a.824.824 0 1 0 0-.706H3.444v.706ZM4.268 8.83a.824.824 0 0 0 .744-.47h4.197v-.706H5.012a.824.824 0 1 0-.744 1.177Z"
                />
              </g>
              <defs>
                <clipPath id="a"><path fill="#fff" d="M0 .125h13v12H0z" /></clipPath>
              </defs>
            </svg>`;if(l.type==="caret")return o`<svg class="icon icon-caret" viewBox="0 0 10 6">
              <path
                fill="currentColor"
                fill-rule="evenodd"
                d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708"
                clip-rule="evenodd"
              />
            </svg> `;if(l.type==="chevron-down")return o`<svg
              class="icon icon-chevron-down"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M4 6L8 10L12 6" stroke="currentColor" />
            </svg> `;if(l.type==="square")return o`<svg width="16px" height="16px" viewBox="0 0 16 16">
              <rect width="16" height="16" fill="none" stroke="currentColor" />
            </svg>`;if(l.type==="checkmark")return o`<svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              class="icon icon-checkmark"
              viewBox="0 0 12 9"
            >
              <path
                fill="currentColor"
                fill-rule="evenodd"
                d="M11.35.643a.5.5 0 0 1 .006.707l-6.77 6.886a.5.5 0 0 1-.719-.006L.638 4.845a.5.5 0 1 1 .724-.69l2.872 3.011 6.41-6.517a.5.5 0 0 1 .707-.006z"
                clip-rule="evenodd"
              />
            </svg> `;if(l.type==="close")return o`<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17">
              <path
                fill="currentColor"
                d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"
              />
            </svg>`;if(l.type==="close-small")return o`<svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              class="icon icon-close-small"
              viewBox="0 0 12 13"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M8.486 9.33 2.828 3.67M2.885 9.385l5.544-5.77"
              />
            </svg>`}}},callbacks:{onSuccessfulAPICall:o=>{var v,m,g,y,_,w,C,F;let r=o.total,f=(r>0?`${(y=(g=(m=(v=window.theme)==null?void 0:v.strings)==null?void 0:m.search)==null?void 0:g.metaTitle)==null?void 0:y.results} - ${window.shopName}`:`${(F=(C=(w=(_=window.theme)==null?void 0:_.strings)==null?void 0:w.search)==null?void 0:C.metaTitle)==null?void 0:F.noResults} - ${window.shopName}`).replace("{{ count }}",r).replace("{{ term }}",o.query);return document.title=G(f),o}}})},At=e=>{B(()=>{cs(e)})};var ds=()=>{class e extends HTMLElement{constructor(){super(),this.selectors={facetsVertical:"[data-facets-vertical]"},this.classes={facetsVerticalAreOpen:"facets-vertical-are-open",facetsHidden:"facets-wrapper-TWP--vertical-hidden"}}connectedCallback(){var s,i;this.button=this.querySelector("button"),this.facetsVertical=(s=this.closest(".shopify-section"))==null?void 0:s.querySelector(this.selectors.facetsVertical),this.facetsVertical?this.setInitialState():document.addEventListener("tagalys-search:vertical-filters-ready",()=>{var a;this.facetsVertical=(a=this.closest(".shopify-section"))==null?void 0:a.querySelector(this.selectors.facetsVertical),this.facetsVertical&&this.setInitialState()},{once:!0}),(i=this.button)==null||i.addEventListener("click",a=>{var c;a.preventDefault(),this.isOpen=!((c=this.facetsVertical)!=null&&c.classList.contains(this.classes.facetsHidden)),this.toggleFacetsVerticalVisibility(!this.isOpen),sessionStorage.setItem("facetsVerticalOpen",!this.isOpen)})}setInitialState(){var s;this.isOpen=!((s=this.facetsVertical)!=null&&s.classList.contains(this.classes.facetsHidden)),this.facetsVerticalState=sessionStorage.getItem("facetsVerticalOpen")?JSON.parse(sessionStorage.getItem("facetsVerticalOpen")):this.isOpen,this.toggleFacetsVerticalVisibility(this.facetsVerticalState)}toggleFacetsVerticalVisibility(s){var i,a;(i=this.button)==null||i.setAttribute("aria-expanded",s),(a=this.facetsVertical)==null||a.classList.toggle(this.classes.facetsHidden,!s),document.body.classList.toggle("facets-vertical-are-open",s)}}customElements.define("facets-vertical-open",e)},qt=ds;var Ot=(e,t=250)=>{let s;return(...i)=>{clearTimeout(s),s=setTimeout(()=>{s=null,e(...i)},t)}};var ps=()=>{class e extends HTMLElement{constructor(){super();$t(this,"debouncedSearch",Ot(()=>{var d,p;let i=this.facetsSearchInput.value;if(this.listItems.length<1)return;let a=0;this.listItems.forEach(u=>{var S;let h=u.querySelector(this.selectors.facetLabel),b=((S=h==null?void 0:h.textContent)==null?void 0:S.toLowerCase())||"";i===""||b.includes(i)?(u.classList.remove("hidden"),a++):u.classList.add("hidden")});let c=(d=this.facetsContainer)==null?void 0:d.querySelector(this.selectors.noSearchResults);c==null||c.classList.toggle("hidden",a>0);let n=(p=this.facetsContainer)==null?void 0:p.querySelector(this.selectors.facetsShowMoreButton);n==null||n.classList.toggle("hidden",a<=this.showMoreNumber)},250));this.selectors={facetsContainer:"[data-facets-container]",facetsItem:"[data-facets-item]",facetLabel:"[data-facet-label]",facetSearchInput:"[data-facets-search-input]",noSearchResults:"[data-facet-search-no-results]",facetsShowMoreButton:"show-more-button"},this.classes={hidden:"hidden"}}connectedCallback(){var i,a,c;this.facetsSearchInput=this.querySelector(this.selectors.facetSearchInput),this.facetsContainer=(i=this.facetsSearchInput)==null?void 0:i.closest(this.selectors.facetsContainer),this.listItems=(a=this.facetsContainer)==null?void 0:a.querySelectorAll(this.selectors.facetsItem),this.showMoreNumber=window.matchMedia("(min-width: 990px)").matches?10:5,(c=this.facetsSearchInput)==null||c.addEventListener("input",this.debouncedSearch)}disconnectedCallback(){var i;(i=this.facetsSearchInput)==null||i.removeEventListener("input",this.debouncedSearch)}}customElements.define("facets-search",e)},Et=ps;var ee=class extends HTMLElement{constructor(){super(),this.selectors={video:"video",control:"[data-video-control]"},this.classes={playing:"autoplay-video__control--playing"}}connectedCallback(){var t,s;this.video=this.querySelector(this.selectors.video),this.control=this.querySelector(this.selectors.control),(t=this.control)==null||t.addEventListener("click",this.togglePlayPause.bind(this)),(s=this.video)==null||s.addEventListener("click",()=>{window.matchMedia("(min-width: 750px)").matches||this.togglePlayPause()})}togglePlayPause(){this.video&&(this.video.paused?(this.video.play(),this.control.classList.add(this.classes.playing)):(this.video.pause(),this.control.classList.remove(this.classes.playing)))}};customElements.define("autoplay-video",ee);(e=>{window.NodeList&&!NodeList.prototype.forEach&&(NodeList.prototype.forEach=Array.prototype.forEach),document.addEventListener("DOMContentLoaded",()=>{var t,s,i,a,c,n;let d={logLevel:(t=e==null?void 0:e.logLevel)!=null?t:"silent",ignoreHidden:(s=e==null?void 0:e.ignoreHidden)!=null?s:!1,minBandwidth:e!=null&&e.minBandwidth?Number(e.minBandwidth):0,reduceData:(i=e==null?void 0:e.reduceData)!=null?i:!1},p=(x,O="")=>{d.logLevel==="verbose"&&window.console.log(`lazyvids: ${x}`,O)},u=(x,O="")=>{d.logLevel!=="silent"&&window.console.warn(`lazyvids: ${x}`,O)},h=typeof window.IntersectionObserver=="function",b;if(d.reduceData&&d.minBandwidth&&(((a=navigator.connection)==null?void 0:a.downlink)<d.minBandwidth||(c=navigator.connection)!=null&&c.saveData)){u(`Slow connection (${(n=navigator.connection)==null?void 0:n.downlink}mbps). Lazy autoplay disabled.`);return}let S=x=>{x.muted=!0,x.autoplay=!0,x.play()!==void 0?x.play().then(()=>x.dataset.lazyvids="loaded").catch(O=>u("Autoplay blocked by browser for:",x)):x.dataset.lazyvids="loaded"},$=x=>{var O,A;if(((O=x.style)==null?void 0:O.display)==="none"||d.ignoreHidden&&((A=x.style)==null?void 0:A.visibility)==="hidden")return!1;let E=getComputedStyle(x);return E.getPropertyValue("display")==="none"||d.ignoreHidden&&E.getPropertyValue("visibility")==="hidden"?!1:x.parentNode&&x.parentNode!==document?$(x.parentNode):!0},k=(x,O)=>{x.forEach(A=>{window.requestAnimationFrame(()=>{let E=A.target;A.isIntersecting!==!1&&$(E)!==!1&&(S(E),O.unobserve(E))})})};h&&(b=new IntersectionObserver(k));let I=x=>{if(h===!1){S(x),u("Unsupported browser. Lazy autoplay disabled.");return}x.dataset.lazyvids="unloaded",b.observe(x)},L="video[data-lazyvids]:not([data-lazyvids=loaded]):not([data-lazyvids=false])",P=document.querySelectorAll(L);p(`Initialised \u2014 ${P.length} ${P.length===1?"video":"videos"} detected`),P.forEach(x=>I(x));let M=x=>{x.forEach(O=>{O.addedNodes.forEach(A=>{if(A.tagName==="VIDEO"&&A.dataset.lazyvids!==void 0&&A.dataset.lazyvids!=="loaded"&&A.dataset.lazyvids!=="false"){I(A);return}A.hasChildNodes()!==!1&&A.querySelectorAll(L).forEach(E=>I(E))})})},R={childList:!0,subtree:!0};new MutationObserver(M).observe(document,R)})})(window.lazyvidsConfig||{});var Rt={shopifySections:".shopify-section",tagalysSearchResults:'[data-tagalys-widget="search-results"]'},Q={header:"section-header",productRecommendations:"product-recommendations-recently",sectionCollection:"section-collection",sectionSearch:"main-search"};document.addEventListener("DOMContentLoaded",()=>{N(),Lt(),B(()=>{var s;(s=window.Tagalys)!=null&&s.Analytics&&typeof window.Tagalys.Analytics.trackPlatformEvents=="function"&&window.Tagalys.Analytics.trackPlatformEvents()}),Ft(),document.querySelectorAll(Rt.shopifySections).forEach(s=>{if(s.classList.contains(Q.header)){St(s);return}if(s.classList.contains(Q.productRecommendations)){Y(s);return}(s.classList.contains(Q.sectionCollection)||s.classList.contains(Q.sectionSearch))&&(qt(),Et()),s.querySelector(Rt.tagalysSearchResults)&&At(s)}),document.addEventListener("shopify:section:load",s=>{let i=s.detail.sectionId;if(i.includes("product_recommendations")){let a=document.getElementById(`shopify-section-${i}`);if(!a)return;Y(a)}}),document.querySelectorAll("[data-copy-button]").forEach(s=>{s.addEventListener("click",()=>kt(void 0,null,function*(){let i=s.dataset.copyButton;if(i)try{yield navigator.clipboard.writeText(i),s.disabled=!0,setTimeout(()=>{s.disabled=!1},1500)}catch(a){window.console.error("Failed to copy text: ",a)}}))})});})();
